import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColumns = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.125 0.25C18.6328 0.25 19.0625 0.445312 19.4531 0.796875C19.8047 1.1875 20 1.61719 20 2.125V15.875C20 16.4219 19.8047 16.8516 19.4531 17.2031C19.0625 17.5938 18.6328 17.75 18.125 17.75H1.875C1.32812 17.75 0.898438 17.5938 0.546875 17.2031C0.15625 16.8516 0 16.4219 0 15.875V2.125C0 1.61719 0.15625 1.1875 0.546875 0.796875C0.898438 0.445312 1.32812 0.25 1.875 0.25H18.125ZM9.375 16.5V2.75H1.25V15.875C1.25 16.0703 1.28906 16.2266 1.40625 16.3438C1.52344 16.4609 1.67969 16.5 1.875 16.5H9.375ZM18.75 15.875V2.75H10.625V16.5H18.125C18.2812 16.5 18.4375 16.4609 18.5547 16.3438C18.6719 16.2266 18.75 16.0703 18.75 15.875Z",
		fill: "currentColor"
	})
});
export default SvgColumns;
